module.exports = __webpack_public_path__ + "static/media/ZOTH.c529781c.png";